import { render, staticRenderFns } from "./BudgetCreate.vue?vue&type=template&id=21789db6&"
import script from "./BudgetCreate.vue?vue&type=script&lang=js&"
export * from "./BudgetCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports